<template>
  <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-basis_6_lg">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ title }}
    </p>
    <p class="emd-card-grid__line">
      {{ $t('after') }}
      {{ computedData.date | dateFormat('date') }},
      {{ $t(descriptionKey) }}
      R$ {{ computedData.value }}
    </p>
  </div>
</template>

<script>
import { BOLETO_PENALTY_ENUM } from '@/enums/boleto-penalty.enum'
import BoletoPenaltyManager from './boletoPenalty.manager'

export default {
  name: 'ChargesPaymentMethodBoletoPenalty',

  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    amount: {
      type: String,
      required: true
    },
    dueAt: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  computed: {
    descriptionKey () {
      return this.type === BOLETO_PENALTY_ENUM.FINE
        ? 'fine-of'
        : 'daily-interest-of'
    },
    computedData () {
      return new BoletoPenaltyManager({
        dueAt: this.dueAt,
        totalAmount: this.amount,
        data: this.data,
        type: this.type
      }).get()
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "after": "Após",
      "fine-of": "multa de",
      "daily-interest-of": "acréscimos diários de"
    },
    "en-US": {
      "after": "Após",
      "fine-of": "fine of",
      "daily-interest-of": "daily interest of"
    }
  }
</i18n>
